import { forwardRef as p, useContext as N, createElement as l, Fragment as S, createContext as _ } from "react";
import C from "../../cache/dist/emotion-cache.browser.esm.js";
import { getRegisteredStyles as P, registerStyles as T, insertStyles as w } from "../../utils/dist/emotion-utils.browser.esm.js";
import { serializeStyles as E } from "../../serialize/dist/emotion-serialize.browser.esm.js";
import { useInsertionEffectAlwaysWithSyncFallback as y } from "../../use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js";
var h = {}.hasOwnProperty, d = /* @__PURE__ */ _(
  typeof HTMLElement < "u" ? /* @__PURE__ */ C({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (d.displayName = "EmotionCacheContext");
d.Provider;
var x = function(r) {
  return /* @__PURE__ */ p(function(e, t) {
    var a = N(d);
    return r(e, a, t);
  });
}, O = /* @__PURE__ */ _({});
process.env.NODE_ENV !== "production" && (O.displayName = "EmotionThemeContext");
var g = function(r) {
  var e = r.split(".");
  return e[e.length - 1];
}, L = function(r) {
  var e = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (e || (e = /^([A-Za-z0-9$.]+)@/.exec(r), e))
    return g(e[1]);
}, z = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), D = function(r) {
  return r.replace(/\$/g, "-");
}, F = function(r) {
  if (!!r)
    for (var e = r.split(`
`), t = 0; t < e.length; t++) {
      var a = L(e[t]);
      if (!!a) {
        if (z.has(a))
          break;
        if (/^[A-Z]/.test(a))
          return D(a);
      }
    }
}, m = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", u = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Z = function(r, e) {
  if (process.env.NODE_ENV !== "production" && typeof e.css == "string" && e.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + e.css + "`");
  var t = {};
  for (var a in e)
    h.call(e, a) && (t[a] = e[a]);
  if (t[m] = r, process.env.NODE_ENV !== "production" && !!e.css && (typeof e.css != "object" || typeof e.css.name != "string" || e.css.name.indexOf("-") === -1)) {
    var s = F(new Error().stack);
    s && (t[u] = s);
  }
  return t;
}, I = function(r) {
  var e = r.cache, t = r.serialized, a = r.isStringTag;
  return T(e, t, a), y(function() {
    return w(e, t, a);
  }), null;
}, A = /* @__PURE__ */ x(function(n, r, e) {
  var t = n.css;
  typeof t == "string" && r.registered[t] !== void 0 && (t = r.registered[t]);
  var a = n[m], s = [t], c = "";
  typeof n.className == "string" ? c = P(r.registered, s, n.className) : n.className != null && (c = n.className + " ");
  var o = E(s, void 0, N(O));
  if (process.env.NODE_ENV !== "production" && o.name.indexOf("-") === -1) {
    var v = n[u];
    v && (o = E([o, "label:" + v + ";"]));
  }
  c += r.key + "-" + o.name;
  var f = {};
  for (var i in n)
    h.call(n, i) && i !== "css" && i !== m && (process.env.NODE_ENV === "production" || i !== u) && (f[i] = n[i]);
  return f.ref = e, f.className = c, /* @__PURE__ */ l(S, null, /* @__PURE__ */ l(I, {
    cache: r,
    serialized: o,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ l(a, f));
});
process.env.NODE_ENV !== "production" && (A.displayName = "EmotionCssPropInternal");
export {
  A as E,
  O as T,
  Z as c,
  h,
  x as w
};
//# sourceMappingURL=emotion-element-6a883da9.browser.esm.js.map
